import { useTranslation } from '@frontend/i18n';

export const ScheduleActivity = () => {
  const { t } = useTranslation('schedule-activity');
  return <div>{t('Schedule Activity')}</div>;
};
